import { useEffect, useState, useRef } from "react";
import { Fuente } from "../../models/riesgo/Fuente";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { InputComponent } from "../../components/InputComponent";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Dialog } from "primereact/dialog";
import { Criterios } from "./Criterios";
import { Consecuencias } from "./Consecuencias";
import { CausaRiesgo } from "./CausaRiesgo";
import { ProgressSpinner } from "primereact/progressspinner";

export const Amenaza = ({ riesgo, id, toast, permss, generic, seccion, nextPrev, handleNext, siguienteTab, setSiguienteTab, setLoadingSave, setLoadingNext, funcionalidades }) => {
    const omodel = new Fuente();
    const defaultValues = generic.default(omodel.model, null);
    const [registers] = useState(null);
    const [tipo, setTipo] = useState(null);
    const [catalogos, setCatalogos] = useState(null);
    const [listar, setListar] = useState(null);
    const [seleccionar, setSeleccionar] = useState(false);
    const [dialogCriterio, setDialogCriterio] = useState(false);
    const [titulo, setTitulo] = useState(null);
    const [lista, setLista] = useState(null);
    const [campo, setCampo] = useState(null);
    const [estilos, setEstilos] = useState(null);
    const [valor, setValor] = useState(null);
    const [dialogConsecuencia, setDialogConsecuencia] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const matrizSrv = new MonitoreoService();
    const { inDrop, inText, inComplete } = InputComponent({ registers: registers, omodel, generic, errors, control, permss, id: getValues('id') });
    const [loading, setLoading] = useState(true);
    const scrollPosition = useRef(0); // Control de la posicion del mouse

    useEffect(() => {
        consultar();
    }, []);

    useEffect(() => {
        if (loading) {
            scrollPosition.current = window.scrollY;
        } else {
            window.scrollTo(0, scrollPosition.current);
        }
    }, [loading]);

    const iniciar = (_values = null, ccolor = null) => {
        const mdl = _values ?? omodel.model;
        const vals = {};
        const style = {};
        const orden = ['probabilidad', 'impacto', 'contagio', 'legal', 'operacional', 'reputacional'];
        Object.keys(mdl).forEach(function (key) {
            vals[key] = mdl[key]?.nombre ?? '';
            style[key] = mdl[key]?.nombre && orden.includes(key) ? colores(mdl[key]?.nombre, {}, ccolor) : {};
        });
        setEstilos(style);
        setValor(vals);
        return vals;
    }

    const consultar = () => {
        setLoading(true);
        const ids = id ?? getValues('id') ?? 0;
        matrizSrv.consultar(`${ids}/${riesgo?.id}/${seccion}`, 'matriz-riesgo-detalle/consulta').then(res => {
            setCatalogos(res.data?.catalogos);
            const _riesgo = res.data?.info;
            let _values = null;
            if (_riesgo && Object.keys(_riesgo).length > 0) {
                _values = generic.renewValues(_riesgo, omodel.model);
                reset(_values);
            }
            const vals = iniciar(_values, res.data?.catalogos?.color);
            if (_values) {
                vals.evaluacion = _values?.evaluacion_riesgo;
                calcular(vals, null, null, res.data?.catalogos);
            }
        }).finally(() => setLoading(false));
    }

    const search = (event, tipo) => {
        if (!event.query.trim().length) {
            setLista([...lista]);
        } else {
            matrizSrv.autoListaMatriz(`matriz-riesgo-criterio/nbuscar/${tipo}`, event.query.toLowerCase(), riesgo?.id).then(res => {
                setLista(res.data);
            });
        }
    }

    const seleccion = (info, listado) => {
        if (listar === 'ambos') {
            const _catalogos = catalogos;
            _catalogos[tipo] = listado;
            setCatalogos(_catalogos);
        } else {
            setValue(campo, info);
            setDialogCriterio(false);
            setTipo(null);
            setSeleccionar(null);
            setListar(null);
        }
    }

    const actualizarCatalogo = (tipo, nuevoListado, padreId = null, nuevoId = null) => {
        setCatalogos(prev => ({ ...prev, [tipo]: nuevoListado }));

        if (padreId && nuevoId) {
            const map = {
                'MTR_RIESGO_PROBABILIDAD': 'probabilidad',
                'MTR_RIESGO_CSC_RIESGO_CONTAGIO': 'contagio',
                'MTR_RIESGO_CSC_LEGAL': 'legal',
                'MTR_RIESGO_CSC_OPERATIVO': 'operacional',
                'MTR_RIESGO_CSC_REPUTACIONAL': 'reputacional',
                'MTR_RIESGO_RANQUEO': 'evaluacion_riesgo',
            };
            const fieldName = map[tipo];
            const valorActual = getValues(fieldName); // Valor aún almacenado en el front

            if (valorActual?.cat_id === padreId) { // Coincide con el editado
                const nuevoValor = nuevoListado.find(item => item.cat_id === nuevoId);
                setValue(fieldName, nuevoValor);
            }
        }
    };

    const onSubmit = (data) => {
        const ids = id ?? getValues('id') ?? 0;
        data.idp = riesgo?.id;
        data.seccion = seccion;
        setLoadingSave(true);
        setLoadingNext(true);
        if (ids <= 0) {
            matrizSrv.nuevo(data, 'matriz-riesgo-detalle/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                if (siguienteTab) {
                    setSiguienteTab(false);
                    handleNext();
                }
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoadingSave(false);
                setLoadingNext(false);
            });
        } else {
            data.id = ids;
            matrizSrv.editar(data, 'matriz-riesgo-detalle/editar').then(res => {
                generic.funcSuccess(res, toast);
                if (siguienteTab) {
                    setSiguienteTab(false);
                    handleNext();
                }
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoadingSave(false);
                setLoadingNext(false);
            });
        }
    }

    const criterios = (opc, ccampo, lis = 'con', sel = false) => {
        setTitulo(omodel?.model[ccampo]?.header);
        setCampo(ccampo);
        setTipo(opc);
        setDialogCriterio(true);
        setSeleccionar(sel);
        setListar(lis);
    }

    const cerrar = () => {
        setDialogCriterio(false);
        setTipo(null);
        setSeleccionar(null);
        setListar(null);
    }

    const mostrarConsecuencia = (tipo, ccampo) => {
        setTitulo(omodel?.model[ccampo]?.header);
        setDialogConsecuencia(true);
        setTipo(tipo);
    }

    const colores = (val, nivel = {}, ccolor = null) => {
        const info = ccolor ?? catalogos?.color;
        const res = { fontSize: '1em', fontWeight: 'bold', display: 'grid', placeItems: 'center', textAlign: 'center' };
        for (let i = 0; i < info.length; i++) {
            const col = info[i];
            const min = parseFloat(col.minimo);
            const max = parseFloat(col.maximo);
            if (val === 0 && min === 0) {
                res.backgroundColor = '#' + col.color;
                res.color = '#' + col.tcolor;
                nivel.nivel = col.nombre;
                break;
            }
            if (val > min && val <= max) {
                res.backgroundColor = '#' + col.color;
                res.color = '#' + col.tcolor;
                nivel.nivel = col.nombre;
                break;
            }
        }
        return res;
    }

    const onChange = (e, val) => {
        const _valor = valor;
        calcular(_valor, e, val);
    }

    const calcular = (_valor, e = null, val = null, ccolor = null) => {
        let style = null;
        let vvalor = null;
        if (e) {
            vvalor = e.value?.nombre ?? 0;
            const value = (val === 'evaluacion_riesgo' ? e.value?.orden : e.value?.nombre) ?? 0;
            style = colores(value);
            _valor[val] = value;
        } else {
            style = colores(_valor?.evaluacion?.orden, {}, ccolor?.color);
            val = 'evaluacion_riesgo';
        }
        const consecuencia = Math.round((
            Number(_valor?.contagio || 0) +
            Number(_valor?.legal || 0) +
            Number(_valor?.operacional || 0) +
            Number(_valor?.reputacional || 0))
            / 4);
        const riesgo_inherente_valor = (consecuencia + Number(_valor?.probabilidad || 0)) / 2;
        const riesgo_nivel = { nivel: null };
        const estilo_riesgo_inherente = colores(riesgo_inherente_valor, riesgo_nivel, ccolor?.color);
        const cconsecuencia = colores(consecuencia, {}, ccolor?.color);
        const impactos = ccolor?.MTR_RIESGO_CONSECUENCIA ?? catalogos?.MTR_RIESGO_CONSECUENCIA;
        const _impacto = impactos?.find(x => x.orden === consecuencia);

        // El estado de catalogos no se actualiza al instante, por lo que debemos usar la copia enviada
        const toleranciaRaw = catalogos?.INH_TOLERANCIA ?? ccolor?.INH_TOLERANCIA;
        const toleranciaNumber = Number(toleranciaRaw);
        const condicion = riesgo_inherente_valor > toleranciaNumber;
        const alerta_tolerancia_riesgo_residual_valor = condicion ? 'ALERTA' : 'NO ALERTA';
        const estilo_alerta_riesgo_inherente = alerta_tolerancia_riesgo_residual_valor === 'ALERTA' ? colores(5, {}, ccolor?.color) : sstyle();

        setEstilos((prevColor) => ({
            ...prevColor,
            ...(val !== null && { [val]: style }),
            consecuencia: cconsecuencia,
            riesgo_inherente_valor: estilo_riesgo_inherente,
            alerta_tolerancia_riesgo_residual: estilo_alerta_riesgo_inherente,
        }));
        setValor((prevValue) => ({
            ...prevValue,
            ...(val !== null && vvalor && { [val]: vvalor }),
            consecuencia: consecuencia,
            riesgo_inherente_valor: riesgo_inherente_valor,
            riesgo_inherente_nivel: riesgo_nivel.nivel,
            alerta_tolerancia_riesgo_residual: alerta_tolerancia_riesgo_residual_valor,
            impacto: _impacto?.nombre
        }));
    }

    const cclase = (col = 1) => {
        const class1 = `field border-1 border-solid border-gray-700 col-${col} m-0`;
        return class1;
    }

    const sstyle = () => {
        const style = { display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'normal', wordWrap: 'break-word', wordBreak: 'break-word', padding: '0.5rem', };
        return style;
    }

    return (
        <>
            {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '300px', color: '#444', fontWeight: '500', fontSize: '1.2rem' }}>
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth={5} />
                    <span style={{ marginTop: '1rem' }}>Cargando información...</span>
                </div>
            ) : (
                <div className="formgrid grid">
                    <div className="field col-8">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="formgrid grid">
                                <div className="field col-12">
                                    {catalogos?.color !== undefined &&
                                        <div className="formgrid grid place-items-center text-center font-bold text-sm">
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.probabilidad?.header}</div>
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.contagio?.header}</div>
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.legal?.header}</div>
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.operacional?.header}</div>
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.reputacional?.header}</div>
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.consecuencia?.header}</div>
                                            <div className={cclase(2)} style={sstyle()}>{omodel?.model?.riesgo_inherente_valor?.header}</div>
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.alerta_tolerancia_riesgo_residual?.header}</div>
                                            <div className={cclase(2)} style={sstyle()}>{omodel?.model?.evaluacion_riesgo?.header}</div>
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.tratamiento_riesgo?.header}</div>

                                            <div className={cclase()} style={estilos?.probabilidad}>{valor?.probabilidad}</div>
                                            <div className={cclase()} style={estilos?.contagio}>{valor?.contagio}</div>
                                            <div className={cclase()} style={estilos?.legal}>{valor?.legal}</div>
                                            <div className={cclase()} style={estilos?.operacional}>{valor?.operacional}</div>
                                            <div className={cclase()} style={estilos?.reputacional}>{valor?.reputacional}</div>
                                            <div className={cclase()} style={estilos?.consecuencia}>{valor?.consecuencia}</div>
                                            <div className={cclase()} style={estilos?.riesgo_inherente_valor}>{valor?.riesgo_inherente_valor}</div>
                                            <div className={cclase()} style={estilos?.riesgo_inherente_valor}>{valor?.riesgo_inherente_nivel}</div>
                                            <div className={cclase()} style={estilos?.alerta_tolerancia_riesgo_residual}>{valor?.alerta_tolerancia_riesgo_residual}</div>
                                            <div className={cclase(2)} style={estilos?.evaluacion_riesgo}>{valor?.evaluacion_riesgo}</div>
                                            <div className={cclase()} style={sstyle()}>{valor?.tratamiento_riesgo}</div>
                                        </div>
                                    }
                                </div>
                                <Divider />
                                {inComplete('fuente_riesgo', lista, search, { hd: omodel.model.fuente_riesgo.header, col: 11, obl: true, valor: 'MTR_RIESGO_FUENTE_RIESGO', lab: 'nombre' })}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Registrar y Buscar"
                                        onClick={() => criterios('MTR_RIESGO_FUENTE_RIESGO', 'fuente_riesgo', 'ninguno', true)} />
                                </div>

                                {inComplete('riesgo', lista, search, { hd: omodel.model.riesgo.header, col: 11, obl: true, valor: 'MTR_RIESGO_RIESGO', lab: 'nombre' })}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Registrar y Buscar"
                                        onClick={() => criterios('MTR_RIESGO_RIESGO', 'riesgo', 'ninguno', true)} />
                                </div>

                                {inText('sigla_riesgo', {}, 2)}
                                {inDrop('probabilidad', catalogos?.MTR_RIESGO_PROBABILIDAD, { lab: 'nombre', chn: onChange, val: 'probabilidad' }, 2)}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar Probabilidades"
                                        onClick={() => mostrarConsecuencia('MTR_RIESGO_PROBABILIDAD', 'probabilidad')} />
                                </div>

                                <Divider />
                                {inDrop('contagio', catalogos?.MTR_RIESGO_CSC_RIESGO_CONTAGIO, { lab: 'nombre', val: 'contagio', chn: onChange }, 2)}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar Contagio"
                                        onClick={() => mostrarConsecuencia('MTR_RIESGO_CSC_RIESGO_CONTAGIO', 'contagio')} />
                                </div>

                                {inDrop('legal', catalogos?.MTR_RIESGO_CSC_LEGAL, { lab: 'nombre', val: 'legal', chn: onChange }, 2)}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar Legal"
                                        onClick={() => mostrarConsecuencia('MTR_RIESGO_CSC_LEGAL', 'legal')} />
                                </div>

                                {inDrop('operacional', catalogos?.MTR_RIESGO_CSC_OPERATIVO, { lab: 'nombre', val: 'operacional', chn: onChange }, 2)}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar Operativo"
                                        onClick={() => mostrarConsecuencia('MTR_RIESGO_CSC_OPERATIVO', 'operacional')} />
                                </div>

                                {inDrop('reputacional', catalogos?.MTR_RIESGO_CSC_REPUTACIONAL, { lab: 'nombre', val: 'reputacional', chn: onChange }, 2)}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar Operativo"
                                        onClick={() => mostrarConsecuencia('MTR_RIESGO_CSC_REPUTACIONAL', 'reputacional')} />
                                </div>

                                <div className="field col-12" style={{ marginTop: '1rem' }}>
                                    <div style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '1rem', backgroundColor: '#f9f9f9', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', lineHeight: '1.5', fontSize: '0.95rem' }}>
                                        <strong>{omodel.model.impacto.header}</strong>
                                        <p style={{ marginTop: '0.5rem', whiteSpace: 'pre-line', textAlign: 'justify' }}>{valor?.impacto}</p>
                                    </div>
                                </div>

                                <div className="field col-5" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                    {inDrop('evaluacion_riesgo', catalogos?.MTR_RIESGO_RANQUEO, { lab: 'nombre', val: 'evaluacion_riesgo', chn: onChange }, 12)}
                                </div>
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '2rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar EVALUACIÓN DEL RIESGO"
                                        onClick={() => mostrarConsecuencia('MTR_RIESGO_RANQUEO', 'evaluacion_riesgo')} />
                                </div>

                                <div className="field col-5" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                    {inDrop('tratamiento_riesgo', catalogos?.MTR_RIESGO_TRATAMIENTO, { lab: 'nombre', val: 'tratamiento_riesgo', chn: onChange }, 12)}
                                </div>
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '2rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar TRATAMIENTO DEL RIESGO"
                                        onClick={() => criterios('MTR_RIESGO_TRATAMIENTO', 'tratamiento_riesgo', 'ambos')} />
                                </div>
                            </div>

                            {nextPrev('ambos')}
                        </form>
                    </div>
                    <div className="col-4">
                        <CausaRiesgo toast={toast} permss={permss} generic={generic} riesgo={riesgo} id={id} funcionalidades={funcionalidades} />
                    </div>
                </div>
            )}

            <Dialog visible={dialogCriterio} header={titulo} modal className="p-fluid dialog-personalizado" onHide={() => {
                cerrar();
            }}
                style={{ maxWidth: '500px' }}>
                {tipo !== null && seleccionar !== null &&
                    <Criterios toast={toast} permss={permss} generic={generic} riesgo={riesgo} tipo={tipo} seleccion={seleccion} seleccionar={seleccionar} listar={listar} funcionalidades={funcionalidades} />}
            </Dialog>

            <Dialog visible={dialogConsecuencia} header={titulo} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogConsecuencia(false);
            }}
                style={{ maxWidth: '500px' }}>
                {tipo !== null &&
                    <Consecuencias toast={toast} permss={permss} generic={generic} riesgo={riesgo} tipo={tipo} id={id} funcionalidades={funcionalidades} actualizarCatalogo={actualizarCatalogo} />}
            </Dialog>
        </>
    )
}
